
import React, { useEffect } from "react";
import pageNotFound from "../assets/images/404-page.png"
import { Image, Button } from "antd";
import "../assets/styles/ErrorStyle.css";

const Error = () => {


  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="error-container">
      <div className="error-content">
        
        <div className="image-container">
          <Image src={pageNotFound} className="error-image" />
        </div>
        
        <div className="text-container">
          <p>We regret to inform you that the page you are attempting to access is either unavailable or restricted.</p>
          <p>Fear not! There are still countless other paths to explore within our domain.</p>
          <p>In the meantime, remember that every closed door is an opportunity to find an open window.</p>
        </div>

        <div className="button-container">
          <Button className="ant-btn ant-btn-primary" onClick={handleGoBack}>Back To Home</Button>
        </div>

      </div>
    </div>
  );
}

export default Error